import { useEffect, useRef, useState } from "react";
import { FieldError, RegisterOptions } from "react-hook-form";
import { BehaviorSubject } from "rxjs";


export function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export function getInitials(name: string) {
    if (name.length === 0) return '';

    var names = name.split(' '),
        initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    } else {
        //split on '.'
        names = name.split('.');
        if (names.length > 1) {
            initials += names[1].substring(0, 1).toUpperCase();
        } else {
            initials = name.substring(0,2).toUpperCase();
        }
    }

    return initials;
}

export const ChatColor = [
    "#0d62c5",
    "#2f9451",
    "#ff3379",
    "#ffb633",
    "#33a3ff",
    "#b6cfed",
    "#e01e5a",
    "#37006f",
    "#3d3f41",
    "#07019f",
    "#17ebff",
    "#31f798",
    "#db5f08",
    "#f5bbcd",
    "#eecbb2",
    "#216839",
    "#600000",
    "#0d62c5",
    "#2f9451",
    "#ff3379",
    "#ffb633",
    "#33a3ff",
    "#b6cfed",
    "#e01e5a",
    "#37006f",
    "#3d3f41",
    "#07019f",
    "#17ebff",
    "#31f798",
    "#db5f08",
    "#f5bbcd",
    "#eecbb2",
    "#216839",
    "#600000",
];

export function getBadgeColor(name: string) {

    let hash = 0, i, chr;
    for (i = 0; i < name.length; i++) {
        chr = name.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    const colorIndex = Math.abs(hash) % ChatColor.length;
    return ChatColor[colorIndex];
}

export function addJsonHeaders(headers: any) {
    if (!Object.keys(headers).includes('Accept')) {
        headers['Accept'] = 'application/json';
    }
    if (!Object.keys(headers).includes('Content-Type')) {
        headers['Content-Type'] = 'application/json';
    }
    return headers as HeadersInit;
}

export async function getImageDimensions(imageUrl: string): Promise<{ width: number, height: number }> {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = function () {
            resolve({ width: img.width, height: img.height });
        };
        img.onerror = function (e) {
            reject(e);
        };
        img.src = imageUrl;
    });
}

export async function fetchAndThrowHttpErrors(input: RequestInfo, init?: RequestInit, customHeaders?: any): Promise<any> {
    if (init) {
        init.headers = addJsonHeaders(init.headers || {});

        if (customHeaders) {
            for (const key of Object.keys(customHeaders)) {
                (init.headers as any)[key] = customHeaders[key];
            }
        }

        for (const key of Object.keys(init.headers)) {
            if (init.headers[key] === null) {
                delete init.headers[key];
            }
        }
    }

    let response = null;
    try {
        response = await fetch(input, init);
    } catch (e) {
    }
    if (!response) {
        throw null;
    }
    if (!response.ok) {
        let json = await response.json();
        throw json;
    }

    try {
        return await response.json();
    } catch (err) {
        return;
    }

}

export async function fetchBinaryAndThrowHttpErrors(method: string, url: string, data: any, progressCallback?: any, loadedCallback?: any, errorCallback?: any): Promise<any> {
    let response = null;
    try {
        // response = await fetch(input, init);

        let request = new XMLHttpRequest();

        request.open(method, url);

        // upload progress event
        request.upload.addEventListener('progress', function (e) {
            // upload progress as percentage
            let percent_completed = (e.loaded / e.total) * 100;
            console.log(percent_completed);
            if (progressCallback) {
                progressCallback(percent_completed);
            }
        });

        // request finished event
        request.addEventListener('load', function (e) {
            // HTTP status message (200, 404 etc)
            console.log(request.status);

            // request.response holds response from the server
            console.log(request.response);
            if (loadedCallback) {
                loadedCallback();
            }
        });

        request.addEventListener('error', function (e) {
            console.log('upload failed : check for cors-anywhere.herokuapp.com authorization if you are in localhost');
            if (errorCallback) {
                errorCallback();
            }
        });

        // send POST request to server
        request.send(data);

    } catch (e) {
    }
}

export async function fetchAndGetText(input: RequestInfo): Promise<any> {
    const response = await fetch(input, null);
    if (!response.ok) {
        let json = await response.json();
        throw json;
    }
    return await response.text();
}
export async function fetchAndGetArrayBuffer(input: RequestInfo): Promise<any> {
    const response = await fetch(input, null);
    if (!response.ok) {
        let json = await response.json();
        throw json;
    }
    return await response.arrayBuffer();
}

// eslint-disable-next-line
export function useMountEffect(fun: any) { return useEffect(fun, []); }

export function useMergeState(initialState: any) {
    const [state, setState] = useState(initialState);
    const setMergedState = (newState: any) =>
        setState((prevState: any) => Object.assign({}, prevState, newState)
        );
    return [state, setMergedState];
}

export function getErrorMessage(error: FieldError, rules: Exclude<RegisterOptions, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>) {
    switch (error?.type) {
        case 'minLength':
            return `This field must have at least ${rules.minLength} characters`;
        case 'maxLength':
            return `This field must have less than ${rules.maxLength} characters`;
        case 'min':
            return `This field must at least ${rules.min}`;
        case 'max':
            return `This field must be less than ${rules.max}`;
        case 'required':
            return 'This field is required';
        case 'validate':
            return 'This field is invalid';
        case 'nameAlreadyTaken':
            return 'This name is already taken';
        default:
            return 'This field is incorrect';
    }
}

export const getOffset = (el) => {
    if (el) {
        const viewportOffset = el.getBoundingClientRect();
        return { top: viewportOffset.top, left: viewportOffset.left };
    }
    return { top: window.innerHeight / 3, left: window.innerWidth / 3 };
}

export const useSharedState = (subject: BehaviorSubject<any>) => {
    const [value, setState] = useState(subject.getValue());
    useEffect(() => {
        let isMounted = true;
        const sub = subject.subscribe(s => {
            if (isMounted) {
                if (!s) {
                    setState('');
                } else {
                    setState(s)
                }
            }
        });
        return () => {
            isMounted = false;
            sub.unsubscribe();
        }
    });
    const newSetState = state => subject.next(state);
    return [value, newSetState];
};

export const useFocus = () => {
    const htmlElRef = useRef(null)
    const setFocus = () => { htmlElRef.current && htmlElRef.current.focus() }
    return [htmlElRef, setFocus]
}

// synchronous sleep
export const sleep = async (delay = 1000) => {
    await new Promise(resolve => setTimeout(resolve, delay))
}

export const ab2str = (buf) => {
    return String.fromCharCode.apply(null, new Uint16Array(buf));
}

export const str2ab = (str) => {
    const buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
    const bufView = new Uint16Array(buf);
    for (let i = 0, strLen = str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
    }
    return buf;
}

export const pickTextColorBasedOnBgColorAdvanced = (bgColor, lightColor, darkColor) => {
    if (!bgColor) return lightColor;
    try {
        const color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
        const r = parseInt(color.substring(0, 2), 16); // hexToR
        const g = parseInt(color.substring(2, 4), 16); // hexToG
        const b = parseInt(color.substring(4, 6), 16); // hexToB
        const uicolors = [r / 255, g / 255, b / 255];
        const c = uicolors.map((col) => {
            if (col <= 0.03928) {
                return col / 12.92;
            }
            return Math.pow((col + 0.055) / 1.055, 2.4);
        });
        var L = (0.2126 * c[0]) + (0.7152 * c[1]) + (0.0722 * c[2]);
        // console.log('pickColor L=', L, bgColor);
        return (L > 0.55) ? darkColor : lightColor;  //  TODO address contrast here
    } catch (e) {
        console.log('error pickColor', bgColor);
        return lightColor;
    }
}

export function hexToComponents(val) {
    let r, g, b, h, s, l, cmin, cmax, delta;
    if (!val) {
        val = "#000000";
    }
    if (val.length === 4) {
        r = parseInt(val[1], 16);
        g = parseInt(val[2], 16);
        b = parseInt(val[3], 16);
    } else if (val.length === 7) {
        r = parseInt(val.substring(1, 3), 16);
        g = parseInt(val.substring(3, 5), 16);
        b = parseInt(val.substring(5, 7), 16);
    }

    const R = r / 255;
    const G = g / 255;
    const B = b / 255;

    cmin = Math.min(R, G, B);
    cmax = Math.max(R, G, B);
    delta = cmax - cmin;

    if (delta === 0) {
        h = 0;
    } else if (cmax === R) {
        h = ((G - B) / delta) % 6;
    } else if (cmax === G) {
        h = (B - R) / delta + 2;
    } else {
        h = (R - G) / delta + 4;
    }
    h = Math.round(h * 60);

    l = (cmax + cmin) / 2;
    s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);

    return {
        r: r,
        g: g,
        b: b,
        h: h,
        s: s,
        l: l,
        a: 1
    };
}

export function hexToColor4Array(hex): any {
    if (!hex) {
        return [0, 0, 0, 255];
    }
    const bigint = parseInt(hex.substring(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return [r, g, b, 255];
}

export function color4ArrayToHex(c4: any[] | null) {
    if (!c4) {
        return '#ffffff';
    }
    let arr = [c4[0], c4[1], c4[2]];
    let str = '#';
    for (let i = 0; i < arr.length; i++) {
        str += ((arr[i] / 16) | 0).toString(16);
        str += ((arr[i] % 16) | 0).toString(16);
    }
    return str;
}

export function makeString(length) {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < length; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

export function compare(a, b, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

export function getCookieValue(name) {
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
}

export function setCookieValue(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

export function normalizeBJNSharingUrl(url: string) {
    const parts = url.split('/');
    if (parts.length <= 1) {
        return url;
    }
    return parts[parts.length - 1];
}

export function toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

export const format = (value) => {
    if (typeof value === 'undefined') return ''
    if (typeof value === 'number') return value
    const tc = toTitleCase(value)
    if (tc === 'x') return ''
    if (tc === ' / ') return ''
    return tc
}

export const identifyBrowser = (full = true) => {
    var regexps = {
        'Chrome': [/Chrome\/(\S+)/],
        'Firefox': [/Firefox\/(\S+)/],
        'MSIE': [/MSIE (\S+);/],
        'Opera': [
            /Opera\/.*?Version\/(\S+)/,
            /Opera\/(\S+)/
        ],
        'Safari': [/Version\/(\S+).*?Safari\//]
    },
        re, m, browser, version;

    const userAgent = navigator.userAgent;
    let elements = 2;
    for (browser in regexps) {
        while (re = regexps[browser].shift()) {
            if (m = userAgent.match(re)) {
                version = (m[1].match(new RegExp('[^.]+(?:\.[^.]+){0,' + --elements + '}')))[0];
                return (full ? browser + ' ' + version : browser.toLowerCase());
            }
        }
    }
    return full ? 'Chrome 99' : 'chrome';
}

const mobileAndTabletCheck = () => {
    let check = false;
    // demoC check on '|ipad|' removed
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window['opera']);
    return check;
};

export const isBrowserOnMobile = () : boolean => {   // callback called with true if device is mobile else false
    // Browser detection

    if ('ontouchstart' in document.documentElement && window.screen.availWidth < 768) {
      console.log('device : ontouchstart is in document.documentElement');
      return true;
    } else {

      // console.log('device : laptop, mouse mode');
      return mobileAndTabletCheck();
    }
  }

